







import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const indexModule = namespace('index')

@Component
export default class Main extends Vue {
  goAccount() {
    this.$router.push('/mine/easte/account')
  }
  goReset() {
    this.$router.push('/mine/easte/modify')
  }
}
